var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldcoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M64.5,23 C85.7629629,23 103,40.2370371 103,61.5 C103,82.7629629 85.7629629,100 64.5,100 C43.2370371,100 26,82.7629629 26,61.5 C26,40.2370371 43.2370371,23 64.5,23 Z M65,50 C58.372583,50 53,55.372583 53,62 C53,68.627417 58.372583,74 65,74 C71.627417,74 77,68.627417 77,62 C77,55.372583 71.627417,50 65,50 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldcoreIcon);
export default __webpack_public_path__ + "static/media/worldcore-icon.b7b9b3d8cb599ee5fbe182b2fa7e976e.svg";
export { ForwardRef as ReactComponent };